/**
 * product item card Vue component
 *
 * @package citrus.vue.product.item
 */
import {Vue} from "ui.vue";
import ProductItem from "./component/App.vue";

Vue.component("CitrusProductItem", ProductItem);